import { Post } from '@tribeplatform/gql-client/types'
import { SvgIcon } from '@tribeplatform/react-ui-kit/Icon'

import { dayjs } from '../../../../common/lib/dayjs.js'
import {
  ExtendedSmartSearchEntity,
  ExtendedSmartSearchEntityType,
} from '../../../SmartSearch.types.js'

interface Props {
  item: ExtendedSmartSearchEntity
  entityType: ExtendedSmartSearchEntityType
}

export const SearchEntityRowTrailing = ({ item, entityType }: Props) => {
  const isPost =
    entityType === ExtendedSmartSearchEntityType.POSTS ||
    entityType === ExtendedSmartSearchEntityType.OFFICIAL_POSTS
  if (!isPost) {
    return null
  }

  return (
    <div className="grid gap-1">
      <div className="hidden sm:block place-self-end text-xs text-content-muted items-center col-span-full">
        <span>
          {(item as Post).space?.name}
          {(item as Post)?.space?.private && (
            <SvgIcon className="ms-1" inline name="lock" />
          )}
        </span>
      </div>
      <div className="sm:place-self-end items-center col-span-full">
        <span className="text-xs text-content-muted">
          {dayjs((item as Post).publishedAt).fromNow()}
        </span>
      </div>
    </div>
  )
}
